const { jQuery: $, themeSettings: config } = window;
import Theme from './modules/theme.class';
import SlickSlider from "./modules/slickslider.class";
import Utils from './modules/utils.class';
import TabbedNav from "./modules/tabbedNav.class";

// require("./lib/slick");
import Slick from "imports-loader?imports=default|jquery|$!./lib/slick";

const theme = new Theme(
    config,
    new SlickSlider(),
    new TabbedNav(Utils),
);

$(() => theme.__onReady());
$(window).on('load', () => theme.__onLoad());
$(window).on('resize', () => theme.__onResize());

$(window).on('kpf:ready', (e, kpf) => theme.__postFilters(kpf));


window.Theme = theme;

Utils.log("Loading Theme...");